import { createCombineMapItem } from '../../../../../reducerRegistry';
import { createReduceObject as createListsCollectionReduceObject } from '../../../../../common/reducers/listsCollection/reducer';

import regionsCollectionSaga from './sagas/regionsCollectionSaga';
import citiesCollectionSaga from './sagas/citiesCollectionSaga';

export default [
  ...createCombineMapItem(
    'regionsCollection',
    createListsCollectionReduceObject,
    [regionsCollectionSaga]
  ),
  ...createCombineMapItem(
    'citiesCollection',
    createListsCollectionReduceObject,
    [citiesCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/reducers/static/collections/reducersMap.js